import { render, staticRenderFns } from "./accessmanagement.vue?vue&type=template&id=289e463f&"
import script from "./accessmanagement.vue?vue&type=script&lang=js&"
export * from "./accessmanagement.vue?vue&type=script&lang=js&"
import style0 from "./accessmanagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports